import LoginCard from './logincard';

export default LoginCard;